// Global Types
import {
  withTranslation,
} from 'react-i18next';

import ChampionshipsListView from './ChampionshipsListView';

const TranslatedComponent = withTranslation()(ChampionshipsListView);

const Component = TranslatedComponent;

export default Component;
